import { useRef, memo } from "react";

// @Utility
import apiDomain from "@utility/app/apiDomain";
import { trackEvent } from "@utility/app/analytics";
// import currencyFormat from "@utility/numbers/currencyFormat";

// JWT & Auth
import { isUserLoggedIn } from "@core/auth/utils";
import { getToken } from "@core/auth/utils";

// Redux & Action
import { useDispatch, useSelector } from 'react-redux';
import { selectGameLike } from "@core/redux/actions/game";

// Component
import { Grid } from "@mui/material";
import ProgressiveImage from "views/components/ProgressiveImage";
import ImageShow from "views/components/ImageShow";
import GotoPage from "views/components/GotoPage";
import GameJackpot from "./GameJackpot";

// services
import { trackPlayer } from "@core/services/appService";

function GameImage({
    item,
    checkPromotion,
    typeGame,
    classSet = "",
    hideLike = null,
    actionLoad = false,
    statusLikeForce = false
}) {
    const pageRef = useRef();
    const dispatch = useDispatch();
    const resultMapLogo = useSelector((state) => state.reduxCamp.resultMapLogo);

    if (item?.like === undefined || item?.like === null) {
        item["like"] = false;
    }

    function getCampLogoByKey(campKey) {
        if (!campKey || !resultMapLogo) return null;

        const key = campKey.toString().trim().toLowerCase();
        return resultMapLogo[key] || null;
    }

    const renderBagde = (item) => {
        if (item.status === 3) {
            return (
                <div className="ribbon ribbonDanger">
                    ปิดปรับปรุง
                </div>
            );
        }
        else if (item.status === 0 || item.status === 1) {
            return (
                <div className="ribbon ribbonWarning">
                    เร็ว ๆ นี้
                </div>
            );
        }
        else if (item.status === 2 || item.status === 4) {
            if (item.spin === 1 || item.promotion === 1) {
                if (checkPromotion === 1 && item.promotion === 1) {
                    return (
                        <div className="ribbon ribbonDanger">
                            ติดโปรโมชั่น
                        </div>
                    );
                }
                else if (item.spin === 1) {
                    return (
                        <div className="ribbon ribbonWarning">
                            ฟรีสปิน
                        </div>
                    );
                }
            }
            else {
                if (item.specials !== "") {
                    let specialType = item.specials.split(",");

                    if (specialType.length > 1) {
                        return (
                            <div className="ribbon ribbonPrimary">
                                มาใหม่
                            </div>
                        );
                    }
                    else {
                        let selectTypeNew = specialType.find((str) => str === "new");
                        let selectTypeHot = specialType.find((str) => str === "hot");

                        if (selectTypeNew) {
                            return (
                                <div className="ribbon ribbonPrimary">
                                    มาใหม่
                                </div>
                            );
                        }

                        if (selectTypeHot) {
                            return (
                                <div className="ribbon ribbonDanger">
                                    ยอดฮิต
                                </div>
                            );
                        }
                    }
                }
            }
        }

        return null;
    };

    const clickLikeStatus = (likeType) => {
        if (isUserLoggedIn()) {
            let entryPage = window.location.pathname.includes("game") ? "game_categories_page" : "home";
            
            trackEvent("game_like_click", {
                entry_page: entryPage,
                game_name: item?.name,
                game_code: item?.code,
                game_camp: item?.camp,
                action: likeType === "add" ? "added" : "removed"
            });

            if (likeType === "add") {
                item["like"] = true;
                item["is_like"] = true;
                dispatch(selectGameLike(item?.id, true, actionLoad));
            }

            if (likeType === "delete") {
                item["like"] = false;
                item["is_like"] = false;
                statusLikeForce = false;
                dispatch(selectGameLike(item?.id, false, actionLoad));
            }
        }
    };

    const renderGameImage = () => {
        if (item === null) return null;

        return (
            <div className="positionRelative gameHover">
                <div className="ribbonPosition">{renderBagde(item)}</div>

                {(item?.mode !== "camp" && !hideLike && isUserLoggedIn()) && (
                    <div className="gameLikePosition">
                        {(item?.like || statusLikeForce || item?.is_like) ? (
                            <ImageShow
                                className="gameLikeIcon"
                                src="/images/game-like/Favorite Active.webp"
                                alt="Icon เกมโปรด"
                                onClick={() => clickLikeStatus("delete")}
                            />
                        ) : (
                            <ImageShow
                                className="gameLikeIcon"
                                src="/images/game-like/Favorite Inactive.webp"
                                alt="Icon เกมโปรด"
                                onClick={() => clickLikeStatus("add")}
                            />
                        )}
                    </div>
                )}

                {checkPromotion === 1 && item.promotion === 1 ? (
                    <ProgressiveImage
                        className={`gameImage cursorPointer positionRelative ${classSet}`}
                        placeholder="/images/bluring/512x512 image games.webp"
                        src={`${item.image}`}
                        style={{ opacity: "0.6" }}
                    />
                ) : isUserLoggedIn() ? (
                    typeGame === "camp" ? (
                        <ProgressiveImage
                            className={`gameImage cursorPointer positionRelative ${classSet}`}
                            placeholder="/images/bluring/512x512 image games.webp"
                            src={`${item.image}`}
                            onClick={() => gotoSlotGameList(item)}
                        />
                    ) : (
                        // <a href={genareateUrl(item)} target="_blank" rel="noreferrer">
                        <div onClick={() => {
                            let entryPage = window.location.pathname.includes("game") ? "game_categories_page" : "home";
                            
                            trackEvent("game_play_click", {
                                entry_page: entryPage,
                                game_name: item?.name,
                                game_code: item?.code,
                                game_camp: item?.camp,
                                mode: "real"
                            });

                            const win = window.open(`/game-portal?redirect=${encodeURIComponent(genareateUrl(item))}`, "_blank");
                            if (!win) {
                                console.warn("Popup blocked");
                                return;
                            }

                            const startTime = Date.now();
                            const timer = setInterval(() => {
                                if (win.closed) {
                                    clearInterval(timer);

                                    const endTime = Date.now();
                                    const duration = endTime - startTime;
                                    const payload = {
                                        game_code: item.code,
                                        game_camp: item.camp,
                                        start_time: new Date(startTime).toISOString(),
                                        end_time: new Date(endTime).toISOString(),
                                        duration, // ms
                                    };

                                    trackPlayer(payload)
                                }
                            }, 1000);
                        }}>
                            <ProgressiveImage
                                className={`gameImage cursorPointer positionRelative ${classSet}`}
                                placeholder="/images/bluring/512x512 image games.webp"
                                src={`${item.image}`}
                            />
                        </div>
                        // </a>
                    )
                ) : (
                    <ProgressiveImage
                        className={`gameImage cursorPointer positionRelative ${classSet}`}
                        placeholder="/images/bluring/512x512 image games.webp"
                        src={`${item.image}`}
                        onClick={() => popupGameDemo(item)}
                    />
                )}

                {
                    item?.mode !== "camp" && (() => {
                        const getLogoList = getCampLogoByKey(item?.camp);

                        return (
                            <div className="gameWinRateBottom widthFull">
                                <div className="positionRelative">
                                    <div className="gameWinRateBox">
                                        <Grid container spacing={{ xs: 0, md: 1 }} alignItems="center">
                                            <Grid item xs={3} md={3} className="center">
                                                {
                                                    getLogoList && (
                                                        <img
                                                            className="gameLogoCampListImage"
                                                            src={getLogoList}
                                                            loading="lazy"
                                                            decoding="async"
                                                        />
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={9} md={9} className="right gameJackpotNumberBox">
                                                <GameJackpot
                                                    jackpot={item.jackpot}
                                                    time_update={item.time_update}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>


                                </div>
                            </div>
                        );
                    })()
                }
            </div>
        );
    };

    const gotoSlotGameList = item => {
        let entryPage = window.location.pathname.includes("game") ? "game_categories_page" : "home";
        trackEvent("game_camp_list_click", {
            entry_page: entryPage,
            camp_name: item?.name,
            camp_code: item?.code
        });
        pageRef.current?.gotoPlayGame?.("slot", item.code);
    };

    const popupGameDemo = (item) => {
        let entryPage = window.location.pathname.includes("game") ? "game_categories_page" : "home";
        trackEvent("game_demo_click", {
            entry_page: entryPage,
            game_name: item?.name,
            game_code: item?.code,
            game_camp: item?.camp
        });
        pageRef.current.openGame("playGame", item);
    };

    const genareateUrl = (item) => {
        let mode = "demo";

        if (isUserLoggedIn()) {
            mode = "real";
        }

        if (item !== undefined && item !== null) {
            let urlOpenGame = "";

            if (item?.is_html) {
                urlOpenGame = `${window.location.origin}/open-game/html?mode=${mode}&camp=${item?.camp.toLowerCase()}&code=${(item?.game_code === undefined || item?.game_code === null) ? item.code : item?.game_code}`;
            }
            else {
                urlOpenGame = `${process.env?.REACT_APP_API_URL || apiDomain(window.location.host)}/general/generate/open-game/${mode}/${(item?.game_code === undefined || item?.game_code === null) ? item.code : item?.game_code}/${item?.camp.toLowerCase()}?url=${window.location.origin}&token=${getToken()}`;
            }

            return urlOpenGame;
        }
    };

    return (
        <>
            <GotoPage ref={pageRef}></GotoPage>

            {
                renderGameImage()
            }
        </>
    );
}

export default memo(GameImage);